export default "__VITE_ASSET__CakH8K01__"